"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOutsideClick = void 0;

var _react = require("react");

var _utils = require("../utils");

const handleOutsideClick = (ref, clickHandler) => event => {
  if (ref.current && !ref.current.contains(event.target)) {
    clickHandler();
  }
};

const useOutsideClick = (ref, clickHandler) => {
  (0, _react.useEffect)(() => {
    var _windowGlobal, _windowGlobal$documen;

    (_windowGlobal = (0, _utils.windowGlobal)()) == null ? void 0 : (_windowGlobal$documen = _windowGlobal.document) == null ? void 0 : _windowGlobal$documen.addEventListener('mousedown', handleOutsideClick(ref, clickHandler));
    return () => {
      var _windowGlobal2, _windowGlobal2$docume;

      (_windowGlobal2 = (0, _utils.windowGlobal)()) == null ? void 0 : (_windowGlobal2$docume = _windowGlobal2.document) == null ? void 0 : _windowGlobal2$docume.removeEventListener('mousedown', handleOutsideClick(ref, clickHandler));
    };
  }, []);
};

exports.useOutsideClick = useOutsideClick;